export default __webpack_public_path__ + "static/media/stats2.b8ec1a4b.png";